import React from 'react';

const Header = () => {
  return (
    <div className="bg-slate-900/50 backdrop-blur-md border-b border-slate-800 sticky top-0 z-40">
      <div className="max-w-7xl mx-auto px-4 py-6">
        <h1 className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-600 mb-2">
          Directorio Digital
        </h1>
        <p className="text-slate-400">Conecta con profesionales destacados</p>
      </div>
    </div>
  );
};

export default Header;
